import { ApostleClassType } from '@apeiron/apostle'
import { MayNull } from '@apeiron/temp'
import { styled } from '@mui/material'
import { ApostleFilterClassGroup } from '@src/components/apostles/list/filter/ApostleClassFilter'
import {
  FilterSection,
  FilterSectionContent,
  FilterSectionHeader,
  FilterSectionTitle
} from '@src/components/share/filter/FilterSection'
import ResetFilter from '@src/components/share/filter/ResetFilter'
import * as R from 'ramda'
import { useTranslation } from 'react-i18next'

const StyledFilterSectionContent = styled(FilterSectionContent)`
  &.MuiAccordionDetails-root {
    padding: 10px 10px 10px 24px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
`

const BountyClassFilterSection = ({
  className,
  onFilterChange,
  value
}: Props) => {
  const selectedClass = value || []

  const { t } = useTranslation()

  const handleOnChange = (value: ApostleClassType[]) => {
    onFilterChange(value)
  }

  const handleOnReset = () => {
    onFilterChange([])
  }

  return (
    <FilterSection className={className} defaultExpanded>
      <FilterSectionHeader>
        <FilterSectionTitle>{t('apostle.filter.class')}</FilterSectionTitle>
        <ResetFilter
          filterCount={R.length(selectedClass)}
          onReset={handleOnReset}
        />
      </FilterSectionHeader>
      <StyledFilterSectionContent>
        <ApostleFilterClassGroup
          selectedValue={selectedClass}
          onSelectionsChange={handleOnChange}
        />
      </StyledFilterSectionContent>
    </FilterSection>
  )
}

type Props = {
  className?: string
  value: MayNull<ApostleClassType[]>
  onFilterChange: (value: ApostleClassType[]) => void
}

export default BountyClassFilterSection
